export default __webpack_public_path__ + "static/Geologica-Regular-4e3d773f20dab22c5c9521f1bfe87ed8.woff2";